import { Route, Routes } from 'react-router-dom'
import Aside from './components/menu/Aside'
import Breadcrumbs from './components/Breadcrumbs'
import Boat from './components/Boat'
import Content from './components/Content'
import { AsyncComponent, AnimationStyle } from './components/AsyncComponent'
import FixedFooter from './components/Footer/FixedFooter/index'
import StaticFooter from './components/Footer/StaticFooter/index'
import Header from './components/Header'
import HeaderLogo from './components/HeaderLogo'
import HeaderRight from './components/HeaderRight'
import Main from './components/Main'
import MainMenu from './components/menu/MainMenu'
import ScrollToTop from './components/ScrollToTop'
import RightContent from "./components/RightContent";
import { TransitionGroup } from 'react-transition-group'
import MobileMenu from './components/menu/MobileMenu'
import MobileShowMenuButton from './components/menu/MobileShowMenuButton'

const menu = [
  { to: "/survey", title: "Fragebogen", subtitle: "Corona & Pause" },
  { to: "/media", title: "Medien", subtitle: "Du hast Zeit" },
  { to: "/history", title: "Historie", subtitle: "Was bisher geschah" },
  { to: "/cooperation", title: "Partner", subtitle: "Kooperationen" }
]

const NotFound = () => (
  <div>404 - Seite kann nicht gefunden werden</div>
)

export default () => (
  <>
    <AnimationStyle />
    <Header height='100px'>
      <HeaderLogo to='/' title='Zur Startseite' />
      <HeaderRight>
        <MobileShowMenuButton />
        <Boat />
      </HeaderRight>
    </Header>
    <Content>
      <Aside>
        <MainMenu menu={menu} />
      </Aside>
      <Main>
        <Breadcrumbs />
        <ScrollToTop>
          <TransitionGroup>
            <Routes>
              <Route exact path='/' element={<AsyncComponent scene={import('./scenes/LandingPage/LandingPage')} />} />
              <Route exact path='/history' element={<AsyncComponent scene={import('./scenes/HistoryPage/HistoryPage')} />} />
              <Route path='/media/*' element={<AsyncComponent scene={import('./scenes/MediaPage/MediaPage')} />} />
              <Route exact path='/cooperation' element={<AsyncComponent scene={import('./scenes/CooperationPage/CooperationPage')} />} />
              <Route exact path='/survey' element={<AsyncComponent scene={import('./scenes/SurveyPage/SurveyPage')} />} />
              <Route exact path='/disclaimer' element={<AsyncComponent scene={import('./scenes/DisclaimerPage/DisclaimerPage')} />} />
              <Route exact path='/contact' element={<AsyncComponent scene={import('./scenes/ContactPage/ContactPage')} />} />
              <Route path='*' element={<NotFound />} />
            </Routes>
          </TransitionGroup>
        </ScrollToTop>
      </Main>
      <RightContent />
      <MobileMenu menu={menu} />
    </Content>
    <footer>
      <FixedFooter />
      <StaticFooter />
    </footer>
  </>
);
